<template>
    <div class="c-star-rating">
        <div class="c-star-rating__star-group">
            <BaseIcon
                v-for="index in maxRating"
                :key="index"
                :icon="getIcon(index)"
                :size="size"
                :color="getColor(index)"
                class="c-star-rating__star"
            />
        </div>
        <slot></slot>
    </div>
</template>

<script>
import { MAX_RATING } from '~coreModules/core/js/product-constants';

export default {
    name: 'StarRating',
    props: {
        maxRating: {
            type: Number,
            default: MAX_RATING,
            validator: rating => rating <= MAX_RATING,
        },
        rating: {
            type: Number,
            default: 0,
        },
        size: {
            type: String,
            default: '16px',
            validator(size) {
                return ['16px', '24px'].includes(size);
            },
        },
    },
    methods: {
        getColor(index) {
            return index <= Math.round(this.rating) ? 'primary' : 'medium-gray';
        },
        getIcon(index) {
            return !Number.isInteger(this.rating) && index === Math.round(this.rating) ?
                'global--star-half' : 'global--star';
        },
    },
};
</script>

<style lang="scss">
.c-star-rating {
    display: inline-flex;
    align-items: center;

    &__star-group {
        display: flex;
    }

    &__star {
        &:not(:last-child) {
            margin-right: $nu-spacer-0pt5;
        }
    }

    &__count {
        margin-left: $nu-spacer-1;
    }
}
</style>
